import { StampProvideReducer } from "../reducer/StampProvideReducer";

export const reducer = StampProvideReducer;
